<template>
  <main>
    <div class="clearfix muted-border border shadow mb3 px0" v-for="item in items" v-bind:key="0">
      <div :key="item.id" style="height:128px;overflow:hidden;">
        <div class="col col-4 px0 relative" style="height:inherit;">
          <img :src="item.image" alt="" class="fit block" style="min-height:100%;object-fit: none;">
          <div class="absolute top-0 right-0 left-0 lightgrey-background p1" style="background:#535c68;">
            <span class="h6 m0 p0 regular white gibson line-height-1">Solgt</span>
          </div>
        </div>
        <div class="col col-8 pl2 pr0">
          <div class="flex flex-column">
            <p class="h6 semi-bold darkblue gibson line-height-2 pt2">
              <span>{{ item.producttitle }}</span>
            </p>
            <p class="h6 darkblue regular line-height-2 mb1">
              {{ formatCurrency(item.amount) }} kr.
            </p>
            <p class="h6 darkblue gibson regular m0 line-height-2 flex justify-start items-start">
              <span class="inline-block">
                <span class="mediumgrey block">
                  Markedspladsen dato
                </span>
                <span>
                  {{ moment(item.timeadd).locale('da').format('LL') }}<br> {{ moment(item.solddate).locale('da').format('LL') }}
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'marketarchive',
  components: {
    loading,
    Simplert
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.show = true
    var data = {operation: 'openjob_partner_old', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.items = res.openjobold
          this.show = false
        },
        response => {
          alert('error')
        }
      )
  },
  methods: {
    formatCurrency (total) {
      var neg = false
      if (total < 0) {
        neg = true
        total = Math.abs(total)
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString()
    }
  },
  data () {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      overlay: 1
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// MarketArchive.vue?98ba2874